import React, { useState, useRef } from "react";
import { Play } from "lucide-react";
import "./css/CareerFairs.css";

const CareerFairs = () => {
  const [videoPlaying, setVideoPlaying] = useState(false);
  const videoRef = useRef(null);

  const handlePlayVideo = () => {
    setVideoPlaying(true);
    if (videoRef.current) {
      videoRef.current.play();
    }
  };

  return (
    <div className="career-fairs-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="career-fairs-content pt-5">
              {/* <h2 className="pt-6">Find Your Dream Career with CLIF AI</h2> */}
              <h2 className="section-title">Resume Builder & Analysis</h2>
              <p className="section-description">
                Upload your current resume to our platform. Our advanced AI
                analyzes your education, skills, experience, and career
                aspirations to create a comprehensive profile.
              </p>
            </div>
          </div>
          <div className="col-lg-6"></div>
        </div>

        <div className="row main-content-row">
          <div className="col-lg-6">
            <div className="row stats-row">
              <div className="col-md-4">
                <div className="stat-card yellow-card">
                  <h3>500+</h3>
                  <p>Resume Builds</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="stat-card pink-card">
                  <h3>5</h3>
                  <p>Cities</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="stat-card purple-card">
                  <h3>50+</h3>
                  <p>Hiring Companies</p>
                </div>
              </div>
            </div>

            <div className="features-list">
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <p>Career fairs and recruitment drives exclusive to CLIF AI</p>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <p>24*7 Available</p>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="video-testimonial-container">
              <div className="video-wrapper">
                <iframe
                  ref={videoRef}
                  className="vimeo-iframe"
                  src={`https://player.vimeo.com/video/1089691071?autoplay=${
                    videoPlaying ? 1 : 0
                  }&controls=0&title=0&byline=0&portrait=0`}
                  allow="autoplay; fullscreen;"
                  allowFullScreen
                  title="Resume Builder Feature"
                  style={{ width: "100%", height: "100%" }}
                />
                {!videoPlaying && (
                  <div
                    className="play-button-overlay"
                    onClick={handlePlayVideo}
                  >
                    <div className="play-button">
                      <Play size={48} />
                    </div>
                  </div>
                )}
                <div className="speaker-info">
                  <div className="speaker-details">
                    <h5>Resume Builder Feature</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerFairs;
